import { Sprite, Loader } from 'pixi.js';
import vars from '../vars';

class BackgroundStage {
  constructor(parent) {
    this.parent = parent;

    this.ref = new Sprite();
    this.sprite = new Sprite(Loader.shared.resources['images/PLAIN_RED'].texture);
    this.ref.addChild(this.sprite);
    this.resize();

    this.parent.addChild(this.ref);
  }

  resize() {
    this.sprite.width = vars.layout.FRAME_WIDTH;
    this.sprite.height = vars.layout.FRAME_HEIGHT;

    this.ref.position.y = 0;
  }

  destroy() {
    this.ref.destroy({ children: true });
  }
}

export default BackgroundStage;
